import type { PbLineItem } from '@/apiTypes'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export type MappedCustomItem = {
	name: string
	category: PbProductType | ''
	subcategory?: PbSubcategory | string
	price: number | string
	quantity: number
	shortDescription: string
}

export type ServiceLineItem = PbLineItem & {
	numberOfDays: string
	mileRadiusForStandardService: string
	amountPerMile: string
	isBundle: boolean
}

export type MerchandiseLineItem = PbLineItem & {
	interiorDescription?: string
	exteriorDescription?: string
	modelNameNumber?: string
	productManufacturer?: string
}

export type CashAdvanceLineItem = PbLineItem & {
	amountPerDeathCertificate?: string | number
}

export const Pb = PbSubcategory

export const MATERIAL_VALUE = {
	BRONZE: 'bronze',
	STEEL: 'steel',
	STAINLESS: 'stainless',
	COPPER: 'copper',
	CONCRETE: 'concrete',
	WOOD: 'wood',
	OTHER: 'other',
}

export const SHELL_VALUE = {
	SQUARE: 'square',
	ROUND: 'round',
}

export const OUTER_BURIAL_CONTAINER_TYPE = {
	LINER: 'liner',
	VAULT: 'vault',
	BOX: 'box',
	OTHER: 'other',
}

export const INTERIOR_LINING_VALUE = {
	CREPE: 'crepe',
	VELVET: 'velvet',
	SATIN: 'satin',
	OTHER: 'other',
}

export const GAUGE_VALUE = {
	SEVEN_GAUGE: '7ga',
	TEN_GAUGE: '10ga',
	TWELVE_GAUGE: '12ga',
	FOURTEEN_GAUGE: '14ga',
	SIXTEEN_GAUGE: '16ga',
	EIGHTEEN_GAUGE: '18ga',
	TWENTY_GAUGE: '20ga',
}

export const SEAL_VALUE = {
	SEAL: 'seal',
	NON_SEAL: 'non-seal',
	NOT_APPLICABLE: 'not applicable',
}

export const OUNCE_VALUE = {
	THIRTY_TWO_OZ: '32oz',
	FORTY_EIGHT_OZ: '48oz',
}
